/// <reference path="./notificationSetting.base.section.ts" />

module Meevo.Plugins.NotificationSetting {
    "use strict";

    export class EmployeeAppointmentsSection extends NotificationSettingBaseSection {
        constructor(
            protected isApplicationModeCO: boolean,
            protected isSingleLocation: boolean,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string
        ) {
            super(isApplicationModeCO, isSingleLocation, sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
        }
    }
}